import { FunctionComponent } from "react";

import { ProgressSpinner } from "primereact/progressspinner";

import "./LoadingRoute.scss";

interface ILoadingRouteProps {
  loadingInformation?: string;
}

export const LoadingRoute: FunctionComponent<ILoadingRouteProps> = (props: ILoadingRouteProps) => {
  const loadingInformation = props.loadingInformation?.length ? props.loadingInformation : "Loading route ...";

  return (
    <div className="route-loading">
      <ProgressSpinner animationDuration="5s" />

      {!!loadingInformation && <span>{loadingInformation}</span>}
    </div>
  );
};
